import { render, staticRenderFns } from "./CreatePublicSwitch.vue?vue&type=template&id=48cf3303&scoped=true&"
import script from "./CreatePublicSwitch.vue?vue&type=script&lang=js&"
export * from "./CreatePublicSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cf3303",
  null
  
)

export default component.exports